
export default (props) => {

    let params = {};

    for (let key in props) {
        switch (key) {
            // case "onChange":
            //     params.onChange = props.onChange;
            //     break;
            default:
                params[key] = props[key];
                break;
        }
    }

    return <input
        {...params}
    />
};